import axios from 'axios'

axios.defaults.withCredentials = true; //让ajax携带cookie
import {Message} from 'element-ui'

const service = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 60000,
});

Array.prototype.container = function (str) {
    for (var i in this) {
        if (this[i] === str) {
            return true;
        }
    }
    return false;
}
service.defaults.headers.post['Content-Type'] = 'application/json';

// 添加一个请求拦截器
service.interceptors.request.use(function (config) {
    if (sessionStorage.getItem('token')) {
        config.headers['token'] = sessionStorage.getItem('token');
        config.headers['uuid'] = sessionStorage.getItem('userID');
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加一个响应拦截器
service.defaults.retry = 4;
service.defaults.retryDelay = 1000;
service.interceptors.response.use(function (response) {
    if (response.data.state === '2015') {
        sessionStorage.clear();
        window.location.href = "#/login";
    }
    if (response.data.state === '2012') {
        Message.error({
            message: '没有权限',
        });
    }
    if (response.data.state === '5001') {
        sessionStorage.setItem("token", response.data.data);
        let config = response.config;
        if (!config || !config.retry) return Promise.reject(response);

        config.__retryCount = config.__retryCount || 0;

        if (config.__retryCount >= config.retry) {
            return Promise.reject(response);
        }
        config.__retryCount += 1;

        config.headers['token'] = sessionStorage.getItem("token");
        config.baseURL = '';
        let backoff = new Promise(function (resolve) {
            setTimeout(function () {
                resolve();
            }, config.retryDelay || 1);
        });

        return backoff.then(function () {
            return axios(config);
        });
    }

    return response;
}, function (error) {
    //console.log(error)
    Message.error({
        message: '系统繁忙，请稍后重试',
    });

    return Promise.reject(error);
});

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js